import styled from 'styled-components';

export const HoverWrapper = styled.div`
  cursor: pointer;
  svg {
    display: none;

    &:first-child {
      display: block;
    }
  }

  &:hover {
    svg {
      display: block;

      &:first-child {
        display: none;
      }
    }
  }


`;



// WEBPACK FOOTER //
// ./src/components/Icon/styledComponents.js